export function htmlProfit() {
  return (
    <>
      <hr />
      <h5>Saldo Líquido</h5>
      <p>
        Trata-se de resultado financeiro das operações do Usuário, após
        descontos (débitos) de todos possíveis encargos e comissões.
      </p>

      {/* Ticket Sale */}
      <h5 className="fw-bold">Tipos de Débitos:</h5>
      <p>
        Segue abaixo a lista de possíveis encargos que debitam do saldo do
        Usuário:
      </p>
      <ul>
        <li>
          <strong>Taxas Externas:</strong> Taxas de Gateways de Pagamento,
          Bancárias, Conversão de Moedas, Impostos, Encargos, dentre outras.
        </li>
        <li>
          <strong>Taxas de Saque:</strong> Caso o saldo seja transferido para
          uma conta bancária ou sacado em espécie, pode haver cobranças
          adicionais.
        </li>
        <li>
          <strong>Taxas da Plataforma:</strong> São taxas de funcionamento,
          administrativas, de parcerias e/ou de manutenção da mesma.
        </li>
        <li>
          <strong>Comissões:</strong> Trata-se de incentivos financeiros pela
          divulgação de Campanhas e demais atividades na Plataforma.
        </li>
      </ul>

      <p>
        É importante verificar as condições, valores e tipos de débitos antes de
        adquirir a sua Campanha na Plataforma, temos uma equipe de Suporte
        preparada para sanar todas as suas dúvidas.
      </p>
    </>
  );
}
